import { z } from 'zod';

export const LoginInput = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof LoginInput>;

export const ChangePasswordInput = z.object({
  current_password: z.string().min(1),
  new_password: z.string().min(8),
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordInput>;

export const ForgotPasswordInput = z.object({
  email: z.string().email(),
});
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordInput>;

export const ResetPasswordInput = z.object({
  token: z.string().min(1),
  new_password: z.string().min(8),
});
export type ResetPasswordInput = z.infer<typeof ResetPasswordInput>;

export const AdminRole = z.enum(['admin', 'onboarding_only']);
export type AdminRole = z.infer<typeof AdminRole>;

export const AdminPublic = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: AdminRole,
  // Owner capability (T-168): an admin who may additionally see margin/
  // profitability. Defaults false so a payload without it is treated as
  // non-owner (fail-closed) — not a new role, just a flag on top of `role`.
  is_owner: z.boolean().default(false),
});
export type AdminPublic = z.infer<typeof AdminPublic>;
